const cardClasses =
    'rounded-2xl p-7 text-white shadow-brand-card bg-primary';

const topRowClasses = 'flex flex-wrap items-start justify-between gap-4';

const titleClasses = 'font-serif text-card-title m-0 text-white!';

const descriptionClasses = 'text-sm text-white/80 mt-3 mb-0 max-w-2xl';

const actionsClasses = 'flex flex-col sm:flex-row gap-3 shrink-0';

const primaryButtonClasses =
    'inline-flex items-center justify-center gap-2 rounded-lg bg-white px-5 py-2.5 ' +
    'text-sm font-semibold text-primary! cursor-pointer transition-all duration-200 ' +
    'hover:[filter:brightness(0.96)] hover:-translate-y-px hover:shadow-btn-hover ' +
    'disabled:opacity-60 disabled:cursor-not-allowed';

const AttorneyNextStepCard = ({ nextStep, isRequesting, onGenerateProjection }) => (
    <div className={cardClasses}>
        <div className={topRowClasses}>
            <div className="min-w-0">
                <h3 className={titleClasses}>{nextStep.title}</h3>
                <p className={descriptionClasses}>{nextStep.description}</p>
            </div>
            <div className={actionsClasses}>
                <button
                    type="button"
                    className={primaryButtonClasses}
                    onClick={onGenerateProjection}
                    disabled={isRequesting}
                >
                    <i className={isRequesting ? 'fas fa-spinner animate-spin' : 'fas fa-file-medical'} />
                    {isRequesting ? 'Submitting...' : nextStep.primaryCtaLabel}
                </button>
            </div>
        </div>
    </div>
);

export default AttorneyNextStepCard;
